export const BUSINESS_UNIT_TYPES = {
    JEWELRY_NAME: 'Jewelry',
    WATCH_NAME: 'Watch',
    JEWELRY_CODE: 'J',
    WATCH_CODE: 'W'
}